export default {
  path: "/SectionContent/ReleaseNotes",
  name: "Release Notes",
  htmlContent: "release_notes.html",
  headings: [
    { id: "ModifiedFields", text: "Modified Fields", type: "heading" },
    { id: "SectionHighlightedTopics", text: "Section – Highlighted Topics", type: "heading" },
    { id: "SectionCrashLocation", text: "Section – Crash Location", type: "heading" },
    { id: "SectionUnitOperatorDetails", text: "Section – Unit / Operator Details", type: "heading" },
    { id: "SectionVehicleDetails", text: "Section – Vehicle Details", type: "heading" },
    { id: "SectionCollisionDetails", text: "Section – Collision Details & Circumstances", type: "heading" },
    { id: "SectionContributingFactors", text: "Section – Contributing Factors", type: "heading" },
    { id: "SectionRoadwayDetails", text: "Section – Roadway Details", type: "heading" },
    { id: "SectionCommercialMotorVehicles", text: "Section – Commercial Motor Vehicles", type: "heading" },
    { id: "SectionNarrative", text: "Section – Narrative", type: "heading" },
    { id: "SectionDiagram", text: "Section – Diagram", type: "heading" },
    { id: "SectionOccupantInformation", text: "Section – Occupant Information", type: "heading" },
    { id: "SectionReportingCrashesWithTrains", text: "Section – Reporting Crashes with Trains", type: "heading" },
    { id: "SectionCrashInvestigation", text: "Section – Crash Investigation", type: "heading" },
  ],
};
